// レコメンドのコンバージョン種別。
// 同じ受注が直接とアシストの両方に記録されうるため、**合算してはならない**。
// 画面はトグルでどちらか一方だけを表示する。
export const ConversionAttribution = {
  // クリックした対象に結び付いた商品が購入された
  // （商品レコメンドはクリックした商品、記事レコメンドはその記事に掲載されている商品）
  DIRECT: 'direct',
  // クリックした訪問者がその後に受注を発生させた（購入商品の一致を問わない）
  ASSIST: 'assist'
} as const

export type ConversionAttribution =
  (typeof ConversionAttribution)[keyof typeof ConversionAttribution]

// 種別ごとの実績。CV数・売上とも注文単位で数える
export interface ConversionMetrics {
  direct_conversions: number
  direct_revenue: number
  assist_conversions: number
  assist_revenue: number
}

// 既定はアシスト。レコメンドが後押しした受注の全体像を先に見せる。
// 従来と同じ数字（クリックした商品が買われた分）は「直接CV」へ切り替えれば得られる
export const DEFAULT_CONVERSION_ATTRIBUTION: ConversionAttribution = ConversionAttribution.ASSIST

/** 表示中の種別に対応する CV数・売上を取り出す */
export const pickConversion = (
  metrics: ConversionMetrics,
  attribution: ConversionAttribution
): { conversions: number; revenue: number } =>
  attribution === ConversionAttribution.DIRECT
    ? { conversions: metrics.direct_conversions, revenue: metrics.direct_revenue }
    : { conversions: metrics.assist_conversions, revenue: metrics.assist_revenue }
